import { render, staticRenderFns } from "./MsisdnFromMsin.vue?vue&type=template&id=1a0f0ffd&"
import script from "./MsisdnFromMsin.vue?vue&type=script&lang=js&"
export * from "./MsisdnFromMsin.vue?vue&type=script&lang=js&"
import style0 from "./MsisdnFromMsin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports